package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.CursorHand: ImageVector
    get() {
        if (_cursorHand != null) {
            return _cursorHand!!
        }
        _cursorHand = Builder(name = "CursorHand", defaultWidth = 106.17.dp, defaultHeight =
                122.88.dp, viewportWidth = 106.17f, viewportHeight = 122.88f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(29.96f, 67.49f)
                curveToRelative(-0.16f, -0.09f, -0.32f, -0.19f, -0.47f, -0.31f)
                curveToRelative(-1.95f, -1.56f, -4.08f, -3.29f, -5.94f, -4.81f)
                curveToRelative(-2.69f, -2.2f, -5.8f, -4.76f, -7.97f, -6.55f)
                curveToRelative(-1.49f, -1.23f, -3.17f, -2.07f, -4.75f, -2.39f)
                curveToRelative(-1.02f, -0.2f, -1.95f, -0.18f, -2.67f, 0.12f)
                curveToRelative(-0.59f, 0.24f, -1.1f, 0.72f, -1.45f, 1.48f)
                curveToRelative(-0.45f, 0.99f, -0.66f, 2.41f, -0.54f, 4.32f)
                curveToRelative(0.11f, 1.69f, 0.7f, 3.55f, 1.48f, 5.33f)
                curveToRelative(1.16f, 2.63f, 2.73f, 5.04f, 3.89f, 6.59f)
                curveToRelative(0.07f, 0.09f, 0.13f, 0.19f, 0.19f, 0.29f)
                lineToRelative(23.32f, 33.31f)
                curveToRelative(0.3f, 0.43f, 0.47f, 0.91f, 0.53f, 1.4f)
                lineToRelative(0.01f, 0.0f)
                curveToRelative(0.46f, 3.85f, 1.28f, 6.73f, 2.49f, 8.54f)
                curveToRelative(0.88f, 1.31f, 2.01f, 1.98f, 3.42f, 1.94f)
                lineToRelative(0.07f, 0.0f)
                verticalLineToRelative(-0.01f)
                horizontalLineToRelative(36.38f)
                curveToRelative(0.09f, 0.0f, 0.17f, 0.0f, 0.26f, 0.01f)
                curveToRelative(2.28f, -0.03f, 4.36f, -0.71f, 6.25f, -2.02f)
                curveToRelative(2.09f, -1.44f, 3.99f, -3.68f, 5.72f, -6.7f)
                curveToRelative(0.03f, -0.05f, 0.06f, -0.11f, 0.1f, -0.16f)
                curveToRelative(0.67f, -1.15f, 1.55f, -2.6f, 2.41f, -4.02f)
                curveToRelative(3.72f, -6.13f, 6.96f, -11.45f, 7.35f, -19.04f)
                lineTo(99.8f, 74.34f)
                curveToRelative(-0.02f, -0.15f, -0.03f, -0.3f, -0.03f, -0.45f)
                curveToRelative(0.0f, -0.14f, 0.02f, -1.13f, 0.03f, -2.46f)
                curveToRelative(0.09f, -6.92f, 0.19f, -15.48f, -6.14f, -16.56f)
                horizontalLineToRelative(-4.05f)
                lineToRelative(-0.04f, 0.0f)
                curveToRelative(-0.02f, 1.95f, -0.15f, 3.93f, -0.27f, 5.86f)
                curveToRelative(-0.11f, 1.71f, -0.21f, 3.37f, -0.21f, 4.95f)
                curveToRelative(0.0f, 1.7f, -1.38f, 3.08f, -3.08f, 3.08f)
                curveToRelative(-1.7f, 0.0f, -3.08f, -1.38f, -3.08f, -3.08f)
                curveToRelative(0.0f, -1.58f, 0.12f, -3.42f, 0.24f, -5.33f)
                curveToRelative(0.41f, -6.51f, 0.89f, -13.99f, -4.33f, -14.93f)
                horizontalLineTo(74.8f)
                curveToRelative(-0.23f, 0.0f, -0.45f, -0.02f, -0.66f, -0.07f)
                curveToRelative(0.04f, 2.36f, -0.12f, 4.81f, -0.27f, 7.16f)
                curveToRelative(-0.11f, 1.71f, -0.21f, 3.37f, -0.21f, 4.95f)
                curveToRelative(0.0f, 1.7f, -1.38f, 3.08f, -3.08f, 3.08f)
                curveToRelative(-1.7f, 0.0f, -3.08f, -1.38f, -3.08f, -3.08f)
                curveToRelative(0.0f, -1.58f, 0.12f, -3.42f, 0.24f, -5.33f)
                curveToRelative(0.41f, -6.51f, 0.89f, -13.99f, -4.33f, -14.93f)
                horizontalLineToRelative(-4.05f)
                curveToRelative(-0.28f, 0.0f, -0.55f, -0.04f, -0.8f, -0.11f)
                verticalLineTo(49.0f)
                curveToRelative(0.0f, 1.7f, -1.38f, 3.08f, -3.08f, 3.08f)
                curveToRelative(-1.7f, 0.0f, -3.08f, -1.38f, -3.08f, -3.08f)
                verticalLineTo(17.05f)
                curveToRelative(0.0f, -5.35f, -2.18f, -8.73f, -4.97f, -10.14f)
                curveToRelative(-1.02f, -0.52f, -2.12f, -0.78f, -3.21f, -0.78f)
                curveToRelative(-1.08f, 0.0f, -2.18f, 0.26f, -3.19f, 0.77f)
                curveToRelative(-2.76f, 1.4f, -4.92f, 4.79f, -4.92f, 10.28f)
                verticalLineToRelative(56.0f)
                curveToRelative(0.0f, 1.7f, -1.38f, 3.08f, -3.08f, 3.08f)
                curveToRelative(-1.7f, 0.0f, -3.08f, -1.38f, -3.08f, -3.08f)
                verticalLineTo(67.49f)
                lineTo(29.96f, 67.49f)
                close()
                moveTo(58.57f, 31.15f)
                curveToRelative(0.26f, -0.07f, 0.53f, -0.11f, 0.8f, -0.11f)
                horizontalLineToRelative(4.24f)
                curveToRelative(0.24f, 0.0f, 0.47f, 0.03f, 0.69f, 0.08f)
                curveToRelative(5.65f, 0.88f, 8.17f, 4.18f, 9.2f, 8.43f)
                curveToRelative(0.39f, -0.18f, 0.83f, -0.29f, 1.3f, -0.29f)
                horizontalLineToRelative(4.24f)
                curveToRelative(0.24f, 0.0f, 0.47f, 0.03f, 0.69f, 0.08f)
                curveToRelative(6.08f, 0.94f, 8.53f, 4.69f, 9.41f, 9.41f)
                curveToRelative(0.15f, -0.02f, 0.31f, -0.04f, 0.47f, -0.04f)
                horizontalLineToRelative(4.24f)
                curveToRelative(0.24f, 0.0f, 0.47f, 0.03f, 0.69f, 0.08f)
                curveToRelative(11.64f, 1.8f, 11.5f, 13.37f, 11.38f, 22.71f)
                curveToRelative(0.0f, 0.33f, -0.01f, 0.68f, -0.01f, 2.35f)
                lineToRelative(0.0f, 0.07f)
                lineToRelative(0.24f, 10.77f)
                curveToRelative(0.01f, 0.11f, 0.01f, 0.23f, 0.0f, 0.34f)
                curveToRelative(-0.45f, 9.16f, -4.07f, 15.12f, -8.24f, 21.98f)
                curveToRelative(-0.7f, 1.14f, -1.41f, 2.32f, -2.34f, 3.93f)
                curveToRelative(-0.02f, 0.04f, -0.04f, 0.08f, -0.07f, 0.13f)
                curveToRelative(-2.18f, 3.8f, -4.7f, 6.71f, -7.57f, 8.69f)
                curveToRelative(-2.92f, 2.02f, -6.16f, 3.06f, -9.71f, 3.1f)
                curveToRelative(-0.09f, 0.01f, -0.19f, 0.01f, -0.28f, 0.01f)
                horizontalLineTo(41.58f)
                verticalLineToRelative(-0.01f)
                curveToRelative(-3.66f, 0.07f, -6.5f, -1.53f, -8.59f, -4.66f)
                curveToRelative(-1.68f, -2.51f, -2.79f, -6.03f, -3.4f, -10.47f)
                lineTo(6.73f, 75.07f)
                curveToRelative(-0.03f, -0.04f, -0.07f, -0.08f, -0.1f, -0.12f)
                curveToRelative(-1.36f, -1.82f, -3.21f, -4.65f, -4.59f, -7.79f)
                curveTo(1.0f, 64.8f, 0.21f, 62.24f, 0.05f, 59.74f)
                curveToRelative(-0.2f, -2.97f, 0.22f, -5.36f, 1.06f, -7.23f)
                curveToRelative(1.05f, -2.32f, 2.72f, -3.83f, 4.74f, -4.66f)
                curveToRelative(1.89f, -0.77f, 4.01f, -0.88f, 6.16f, -0.45f)
                curveToRelative(2.57f, 0.51f, 5.22f, 1.81f, 7.49f, 3.68f)
                curveToRelative(1.86f, 1.54f, 4.95f, 4.07f, 7.95f, 6.52f)
                lineToRelative(2.52f, 2.06f)
                verticalLineTo(17.18f)
                curveToRelative(0.0f, -8.14f, 3.63f, -13.39f, 8.28f, -15.76f)
                curveTo(40.12f, 0.47f, 42.17f, 0.0f, 44.23f, 0.0f)
                curveToRelative(2.05f, 0.0f, 4.1f, 0.48f, 5.98f, 1.43f)
                curveToRelative(4.69f, 2.37f, 8.36f, 7.62f, 8.36f, 15.62f)
                verticalLineTo(31.15f)
                lineTo(58.57f, 31.15f)
                close()
            }
        }
        .build()
        return _cursorHand!!
    }

private var _cursorHand: ImageVector? = null
